// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"_2zYRWk_P-LyxKCjlpyV8Rp","Label":"_2mOXkyM8bjk2z2iAPFWrPm","Less":"_20ieqjRSzAh0JFxLlYiEBN","More":"_29mgQtEdbttG_ubTWwJA8N"};